/* Spec PARTNER-002 D-12 (copia do admin-app, ADMIN-002 D-10) — para onde voltar depois de entrar (?voltar=). So caminho interno do app: comeca com "/",
   nao com "//" ou "/\" (outro site), sem espaco, e nunca uma tela publica (evita voltar para a propria entrada). */

const PUBLIC_PATHS = ['/entrar', '/pedir-acesso', '/esqueci-a-senha']

export function safeReturnPath(value: unknown): string | undefined {
    if (typeof value !== 'string' || value.length > 512 || !/^\/(?![/\\])[^\s]*$/.test(value)) return undefined
    const path = value.split(/[?#]/)[0]!
    if (path === '/' || PUBLIC_PATHS.some(p => path === p || path.startsWith(`${p}/`))) return undefined
    return value
}
